import { render, staticRenderFns } from "./LayoutDetail.vue?vue&type=template&id=5643ec56&"
import script from "./LayoutDetail.vue?vue&type=script&lang=js&"
export * from "./LayoutDetail.vue?vue&type=script&lang=js&"
import style0 from "./LayoutDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports